import { createStackNavigator } from "@react-navigation/stack";

import Login from "./screens/Login";
import ResetPassword from "./screens/ResetPassword";
import Register from "./screens/Register";
import ScanQRCode from "./components/ScanQRCode";
import UnityDetails from "./screens/UnityDetails";
import Menu from "./screens/Menu";
import CodeVerification from "./components/CodeVerification";
import ChangePassword from "./screens/ChangePassword";
import PaymentTicket from "./screens/PaymentTicket"
import CreditCardForm from './screens/CreditCardForm'
import Wallet from "./screens/Wallet";
import PaymentReceipt from './screens/PaymentReceipt'
import Preferences from "./screens/Perfil/screens/Preferences";
import { AuthContext } from "./contexts/auth";
import { useContext } from "react";
import PaymentHistoric from "./screens/PaymentHistoric";
import PaymentSessionHistory from "./screens/PaymentSessionHistory";
import Contact from "./screens/Perfil/screens/Contact";
import About from "./screens/Perfil/screens/About";
import AccountInfo from "./screens/Perfil/screens/AccountInfo"
import VehiclesForm from "./screens/VehiclesForm";
import VehiclesList from "./screens/VehiclesList";
import Services from "./screens/Services";
import UnityList from "./screens/UnityList"
import ContractForm from "./screens/ContractForm";
import InfoTable from "./screens/ContractForm/components/InfoTable";
import ProportionalTable from "./screens/ContractForm/components/ProportionalTable";
import PaymentContract from "./screens/PaymentContract";
import ContractList from "./screens/ContractList";
import ContractDetails from "./screens/ContractDetails";
import BillingList from "./screens/BillingList";
import CredentialList from "./screens/CredentialList";
import CredentialForm from "./screens/CredentialForm";
import CoinPrice from "./screens/CoinPrice";
import PaymentCoin from "./screens/PaymentCoin";
import WalletShared from "./screens/WalletShared";
import WalletTransfer from "./screens/WalletTransfer";
import CreditCardList from "./screens/CreditCardList"
import WalletFractionList from "./screens/WalletFractionList";
import WalletFractionForm from "./screens/WalletFractionForm";
import WalletFractionShare from "./screens/WalletFractionShare";
import PaymentQRCode from "./screens/PaymentQRCode";
import ScanQRCodeVirtualStamp from "./components/ScanQRCodeVirtualStamp";
import Home from "./screens/Home";
import MyVehicles from "./screens/MyVehicles";
import MyVehiclesAdd from "./screens/MyVehiclesAdd";
import OrderVehicle from "./screens/OrderVehicle";
import DigitalCredential from "./screens/Perfil/screens/DigitalCredential";

import { IS_WEB } from "@services/Config";

// import InitialOnboarding from './screens/Onboarding/initial'

const Stack = createStackNavigator();

export default function Routes({onboarded}) {
    const { isSignUp, loginType } = useContext(AuthContext)
    return <Stack.Navigator
        initialRouteName={onboarded ? 'Login' : 'InitialOnboarding'}  //"Login"
        screenOptions={{
            headerShown: false,
            cardStyle: {
                backgroundColor: "#FFF",
            },
        }}>
       { !isSignUp ? (<>
            {/* <Stack.Screen name="InitialOnboarding" component={InitialOnboarding} options={{ title: "Onboarding" }} /> */}
            <Stack.Screen name="Login" component={Login} options={{ title: "Login" }} />
            <Stack.Screen name="Cadastro" component={Register} options={{ title: "Cadastro" }} />
            <Stack.Screen name="EsqueceuSenha" component={ResetPassword} options={{ title: "Esqueceu a Senha" }} />
            <Stack.Screen name="CodeVerification" component={CodeVerification} options={{ title: "Código de verificação" }} />
            <Stack.Screen name="ChangePassword" component={ChangePassword} options={{ title: "Mude sua senha" }} />
            <Stack.Screen name="PaymentSessionHistory" component={PaymentSessionHistory} options={{ title: "Histórico da Sessão" }} />
        </>) :
        (<> 
            {
                loginType === "autologin" ? (
                    <>
                        <Stack.Screen name="Login" component={Login} options={{ title: "Login" }} />
                        <Stack.Screen name="ScanQRCode" component={ScanQRCode} options={{ title: "Pagar via QR" }} />
                        <Stack.Screen name="PaymentTicket" component={PaymentTicket} options={{ title: "Pagar meu ticket" }} />
                        <Stack.Screen name="PaymentQRCode" component={PaymentQRCode} options={{ title: "Leia seu ticket" }} />
                        <Stack.Screen name="PaymentReceipt" component={PaymentReceipt} options={{ title: "Recibo" }} />
                        <Stack.Screen name="PaymentSessionHistory" component={PaymentSessionHistory} options={{ title: "Histórico da Sessão" }} />
                    </>
                ) : (
                    <>
                        <Stack.Screen name="Menu" component={Menu} options={{ title: "Menu" }} />
                        <Stack.Screen name="Home" component={Home} options={{ title: "Inicio" }} />
                        <Stack.Screen name="ScanQRCode" component={ScanQRCode} options={{ title: "Pagar via QR" }} />
                        <Stack.Screen name="PaymentTicket" component={PaymentTicket} options={{ title: "Pagar meu ticket" }} />
                        <Stack.Screen name="PaymentQRCode" component={PaymentQRCode} options={{ title: "Leia seu ticket" }} />
                        <Stack.Screen name="PaymentReceipt" component={PaymentReceipt} options={{ title: "Recibo" }} />
                        <Stack.Screen name="PaymentSessionHistory" component={PaymentSessionHistory} options={{ title: "Histórico da Sessão" }} />
                    </>
                )
            }
            {/*<Stack.Screen name="Contact" component={Contact} options={{ title: "Contato" }} />
            <Stack.Screen name="CodeVerification" component={CodeVerification} options={{ title: "Código de verificação" }} />
            <Stack.Screen name="UnityDetails" component={UnityDetails} options={{ title: "Detalhes da Unidade" }} />
            <Stack.Screen name="ChangePassword" component={ChangePassword} options={{ title: "Mude sua senha" }} />
            <Stack.Screen name="CreditCardForm" component={CreditCardForm} options={{ title: "Cadastro de cartão" }} />
            <Stack.Screen name="Wallet" component={Wallet} options={{ title: "Carteira" }} />
            <Stack.Screen name="Preferences" component={Preferences} options={{ title: "Preferencias" }} />
            <Stack.Screen name="About" component={About} options={{ title: "Ajuda" }} />
            <Stack.Screen name="AccountInfo" component={AccountInfo} options={{ title: "Dados da Conta" }} />
            <Stack.Screen name="VehiclesForm" component={VehiclesForm} options={{ title: "Adicionar Veiculo" }} />
            <Stack.Screen name="VehiclesList" component={VehiclesList} options={{ title: "Meus Veiculos" }} />
            <Stack.Screen name="Services" component={Services} options={{ title: "Serviços" }} />
            <Stack.Screen name="UnityList" component={UnityList} options={{ title: "Lista de Unidades" }} />
            <Stack.Screen name="Contract" component={ContractForm} options={{ title: "Contrato" }} />
            <Stack.Screen name="InfoTable" component={InfoTable} options={{ title: "Informações da tabela" }} />
            <Stack.Screen name="ProportionalTable" component={ProportionalTable} options={{ title: "Tabela Proporcional" }} />
            <Stack.Screen name="PaymentContract" component={PaymentContract} options={{ title: "Pagar mensalidade" }} />
            <Stack.Screen name="ContractList" component={ContractList} options={{ title: "Lista de contratos" }} />
            <Stack.Screen name="ContractDetails" component={ContractDetails} options={{ title: "Detalhes do contrato" }} />
            <Stack.Screen name="BillingList" component={BillingList} options={{ title: "Cobranças em aberto" }} />
            <Stack.Screen name="CredentialList" component={CredentialList} options={{ title: "Minhas Credenciais" }} />
            <Stack.Screen name="CredentialForm" component={CredentialForm} options={{ title: "Adicionar Credencial" }} />
            <Stack.Screen name="CoinPrice" component={CoinPrice} options={{ title: "Adicione Créditos" }} />
            <Stack.Screen name="PaymentCoin" component={PaymentCoin} options={{ title: "Pagar créditos" }} />
            <Stack.Screen name="WalletShared" component={WalletShared} options={{ title: "Compartilhar carteira" }} />
            <Stack.Screen name="WalletTransfer" component={WalletTransfer} options={{ title: "Transferir" }} />
            <Stack.Screen name="CreditCardList" component={CreditCardList} options={{ title: "Cartões cadastrados" }} />
            <Stack.Screen name="WalletFractionList" component={WalletFractionList} options={{ title: "Frações" }} />
            <Stack.Screen name="WalletFractionForm" component={WalletFractionForm} options={{ title: "Nova Fração" }} />
            <Stack.Screen name="WalletFractionShare" component={WalletFractionShare} options={{ title: "Compartilhar Fração" }} />
            <Stack.Screen name="ScanQRCodeVirtualStamp" component={ScanQRCodeVirtualStamp} options={{ title: "Leia seu ticket" }} />
            <Stack.Screen name="MyVehicles" component={MyVehicles} options={{ title: "Meus veículos" }} />
            <Stack.Screen name="MyVehiclesAdd" component={MyVehiclesAdd} options={{ title: "Novo veículo" }} />
            <Stack.Screen name="OrderVehicle" component={OrderVehicle} options={{ title: "Pedir veículo" }} />
            <Stack.Screen name="DigitalCredential" component={DigitalCredential} options={{ title: "Credencial Digital" }} />*/}
        </>)}
    </Stack.Navigator>
}